import React from 'react' // eslint-disable-line no-unused-vars
import Footer from '../Footer'
import { addNotification as notify } from 'reapop'
import connect from 'react-redux/es/connect/connect'
import AdminNavigation from './AdminNavigation'

class AdminPanel extends React.Component {
  render () {
    const languageContent = this.props.pageContent.content

    return (
      <div className='page-container'>
        <div className='page-content'>
          <div className='v2_container'>
            <div className='row'>
              <AdminNavigation className='col-xl-2 col-lg-3 col-md-4 col-6' />
              <div className='col-xl-10 col-lg-9 col-md-8 col-6 p-l-15'>
                <div className='row'>
                  <div className='col-12 col-xl-12'>
                    <h3 className='mb-3 header-primary'>Header goes here..</h3>
                    <p> {languageContent.module.admin.localProduct.subheading}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

function mapStateToProps ({ pageContent }) { return { pageContent } }

export default connect(mapStateToProps, { notify })(AdminPanel)



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AdminPanel.js